import { AtimInterface, HitchType } from "protos/atk/enums";
import {
  atimInterfaceToLocaleString,
  hitchTypeToLocaleString,
} from "common/utils/enumTranslations";
import {
  capitalize,
  FormControl,
  FormControlLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import { FormikTextInput } from "common/components/FormikTextInput";
import { ImplementArchetypeViewModel } from "../ImplementArchetypeViewModel";
import { MuiErrorMessage } from "common/components/MuiErrorMessage";
import { typedPath } from "typed-path";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

const S = typedPath<ImplementArchetypeViewModel>();

export const BasicInfoStep: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const formikProps = useFormikContext<ImplementArchetypeViewModel>();
  const { t } = useTranslation();
  return (
    <Paper className="flex flex-col p-4 gap-4">
      <FormikTextInput
        name={S.make.$path}
        label={capitalize(t("models.equipment.make_one"))}
        disabled={disabled}
      />
      <FormikTextInput
        name={S.model.$path}
        label={capitalize(t("models.equipment.model_one"))}
        disabled={disabled}
      />
      <FormikTextInput
        name={S.series.$path}
        label={capitalize(t("models.equipment.series"))}
        disabled={disabled}
      />
      <div className="flex flex-col">
        <Typography>{capitalize(t("models.equipment.hitchType"))}</Typography>
        <FormControl disabled={disabled}>
          <RadioGroup
            className="flex gap-2"
            row
            value={formikProps.values.hitchType}
            onChange={(e) =>
              formikProps.setFieldValue(
                S.hitchType.$path,
                Number.parseInt(e.target.value)
              )
            }
          >
            <FormControlLabel
              value={HitchType.HITCH_TYPE_THREE_POINT_REAR}
              control={<Radio />}
              label={t(
                hitchTypeToLocaleString(HitchType.HITCH_TYPE_THREE_POINT_REAR)
              )}
            />
            <FormControlLabel
              value={HitchType.HITCH_TYPE_THREE_POINT_FRONT}
              control={<Radio />}
              label={t(
                hitchTypeToLocaleString(HitchType.HITCH_TYPE_THREE_POINT_FRONT)
              )}
            />
            <FormControlLabel
              value={HitchType.HITCH_TYPE_DRAW_BAR_REAR}
              control={<Radio />}
              label={t(
                hitchTypeToLocaleString(HitchType.HITCH_TYPE_DRAW_BAR_REAR)
              )}
            />
          </RadioGroup>
        </FormControl>
        <MuiErrorMessage name={S.hitchType.$path} />
      </div>
      <div className="flex flex-col">
        <Typography>{t("models.equipment.atimInterface")}</Typography>
        <Select
          displayEmpty
          value={formikProps.values.atim}
          onChange={(e) =>
            formikProps.setFieldValue(S.atim.$path, e.target.value)
          }
          disabled={disabled}
        >
          <MenuItem value={undefined}>{t("utils.descriptors.none")}</MenuItem>
          <MenuItem value={AtimInterface.ATIM_LASER_WEEDER}>
            {t(atimInterfaceToLocaleString(AtimInterface.ATIM_LASER_WEEDER))}
          </MenuItem>
        </Select>
      </div>
    </Paper>
  );
};
